import React from "react";
import { Box } from "@mui/material";

/**
 * ResizeHandle
 *
 * Drop this at the end of any header cell (th or div).
 * The parent cell must have  position: "relative"  for the handle to anchor correctly.
 *
 * Props:
 *   handleProps  — spread the object returned by getHandleProps(index)
 */
const ResizeHandle = ({ handleProps = {} }) => (
  <Box
    {...handleProps}
    sx={{
      position: "absolute",
      right: 0,
      top: 0,
      bottom: 0,
      width: "6px",
      cursor: "col-resize",
      zIndex: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover > div, &:active > div": { opacity: 1 },
    }}
  >
    <Box
      sx={{
        width: "2px",
        height: "55%",
        borderRadius: "2px",
        background: "rgba(40,179,180,0.55)",
        opacity: 0,
        transition: "opacity 0.15s",
        pointerEvents: "none",
      }}
    />
  </Box>
);

export default ResizeHandle;